
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
            inlineAccountTabs: {
                show: false,
                title: 'Create an account',
                tabIndex: 0,
                merge: {}
            },
        }
    },
    computed: {
        ...mapGetters([
            'client'
        ]),
    },
    methods: {
        showTab (index, merge = {}) {
            this.inlineAccountTabs.merge = merge
            this.inlineAccountTabs.tabIndex = index
            this.inlineAccountTabs.show = true
        }
    }
}
